import useNav from "../connectors/nav/useNav";
import { FormattedMessage } from "react-intl";
import MountAfterDelay from "../../../../common/ui/MountAfterDelay";
import OffScreen from "../../../../common/ui/OffScreen";

export default function PageLoadAnnounce() {
  const { isPageLoading } = useNav();

  if (isPageLoading) {
    // Handled by ContentLoader
    // Rapid message flips between loaded and not don't always get read.
    // Pulling this out separately seems to announce more consistently.
    return null;
  }

  return (
    <OffScreen>
      <div role="status">
        {/* "status" specs say the container should exist before content is added */}
        <MountAfterDelay timeout={50}>
          <FormattedMessage id="nav.pageLoaded" />
        </MountAfterDelay>
      </div>
    </OffScreen>
  );
}
